import * as actions from "./actionsTypes";

const initialData = {
  loaderDescCompetencie: false,
  loaderDescCompetencies: false,
  saveLoaderDescCompetencie: false,
  desccompetencies: null,
  desccompetencie: null,
  desccompetenciesFaild: null,
  desccompetencieFaild: null,
  formDescCompetencieFaild: null  
};

export default function DescCompetenciesReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADER_DESC_COMPETENCIE:
      return { ...state, loaderDescCompetencie: action.payload };
    case actions.LOADER_DESC_COMPETENCIES:
      return { ...state, loaderDescCompetencies: action.payload };
    case actions.SAVE_LOADER_COMPETENCIES:
      return { ...state, saveLoaderDescCompetencie: action.payload };
    case actions.GET_DESC_COMPETENCIE:
      return { ...state, desccompetencie: action.payload };
    case actions.GET_DESC_COMPETENCIES:
      return { ...state, desccompetencies: action.payload };
    case actions.DESC_COMPETENCIE_FAIL:
      return { ...state, desccompetencieFaild: action.payload }
    case actions.DESC_COMPETENCIES_FAIL:
      return { ...state, desccompetenciesFaild: action.payload };
    case actions.FORM_DESC_COMPETENCIEFAIL:
      return { ...state, formDescCompetencieFaild: action.payload };
    default:
      return state;
  }
}
